import { createAction } from "@reduxjs/toolkit";

export const setMeasurementSystem = createAction("measurement/SET_SYSTEM", (payload: boolean) => ({ payload: payload }));